import React, { useContext, useState, useEffect } from 'react';
import { HybirdContext, withHybird } from './containers/HybirdContext.container';
import HeaderSection from './containers/Header.container';
import MagicSection from './containers/Magic.container';
import SpotLights from './components/spotlights';
import CardContainer from './containers/Card.container';
import './App.css';
import axios from 'axios';
import VConsole from './containers/VConsole.container';
import Error from './components/Error';
import get from 'lodash/get';
import map from 'lodash/map';
import join from 'lodash/join';
import { camelTitle } from './utils/camelTitle';
import { Loading } from './Loading';


function App() {
  const hybirdContext = useContext(HybirdContext);
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(false);
  const [language, setLanguage] = useState('');
  const [cdnHost, setCDNhost] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const _language = await hybirdContext.getLanguage();
      console.log("测试数据4");
      // alert('_language_language_language---', _language)
      console.log('_language_language_language', _language);
      try {
        const result = await axios(
          `/anniversary/api/content/${_language}`
        );
        setData(result.data);
        setLanguage(_language);
        const { images, campaigns } = result.data;
        const [first, second] = images;
        const campaignAnalyticStr = join(map(campaigns, (campaign, index) => {
          return `${index + 1}:${camelTitle(campaign.title)}`
        }), ',');
        hybirdContext.trackState('tools/harmony/landing', JSON.stringify({ 's.list1': `L:${camelTitle(get(first, 'title'))},R:${camelTitle(get(second, 'title'))},${campaignAnalyticStr}` }));
      } catch (e) {
        setError(true);
        setLanguage(_language);
      }

    };

    fetchData();
  }, [hybirdContext]);


  useEffect(() => {
    const getEnv = async () => {
      try {
        const result = await axios(`/anniversary/api/configs`);
        setCDNhost(result.data.cdnHost);
        const fontUrl = result.data.cdnHost + '/pep/media/pep/live/media/site/font/InspireTWDC_Web/fonts.css';
        const font = document.createElement('link');
        font.rel = 'stylesheet';
        font.href = fontUrl;
        document.head.appendChild(font);
      } catch (e) {
        setError(true);
      }
    };
    getEnv();
  }, [hybirdContext]);

  const onClickDebugBanner = () => {
    hybirdContext.showBanner('test from Harmony', 'TEST string content from harmony landing page??!!');
  };
  const onTrackState = (name, context, cb) => {
    name && hybirdContext.trackState(name, context, cb)
  };
  const onTrackAction = (name, context, cb) => {
    name && hybirdContext.trackAction(name, context, cb)
  };
  const onGotoTC = () => {
    hybirdContext.gotoTC();
  };
  const onClickShare = () => {
    // TODO: share api
    console.log('onClickShare')
  };
  if (error) {
    const errorConfig = language === 'en' ? {
      title: 'We’re Working on It',
      description: `This page is temporarily unavailable. Rest assured, we’ll fix the issue soon, so please try again later.`
    } : {
      title: '我们正在处理',
      description: `页面当前不可用。请放心，问题很快将会得到解决，请稍后重试。`
    };
    return <Error {...errorConfig} />;
  }
  return !!data ? (
    <div className="App">
      <HeaderSection data={data} />
      <SpotLights data={data} onShareClick={onClickShare} onGotoTC={onGotoTC} onTrackState={onTrackState} onTrackAction={onTrackAction}>
        {
          data.campaigns.map((d, key) => (
            <CardContainer key={key} data={{ ...d, readMoreText: data.readMoreText, hideDetailText: data.hideDetailText }} />
          ))
        }
      </SpotLights>
      <MagicSection data={data} />
      {data && data.debugMode && <div>
        <h5>Toggle Debug Mode Enabled</h5>
        <button onClick={onClickDebugBanner}>
          Harmony H5 Landing
        </button>
        <VConsole />
      </div>}
    </div>
  ) : (
    <div className="app-loading">
      <div className="loader-overlay">
        <Loading />
      </div>
    </div>
  );
}

export default withHybird(App);
